export interface CustomTheme {
    base: string;
    inherit: boolean;
    rules: Array<{
        token: string;
        foreground: string;
        fontStyle?: string;
    }>;
    colors: {
        [key: string]: string;
    };
}

export const customTheme: CustomTheme = {
    base: 'vs-dark',
    inherit: true,
    rules: [
        { token: 'comment', foreground: '#9999a9', fontStyle: 'italic' },
        { token: 'string', foreground: 'ce9178' },
    ],
    colors: {
        'editor.background': '#23233c',
        'editor.foreground': '#ffffff',
        'editor.lineHighlightBackground': '#23233c',
        'editorCursor.foreground': '#2881daff',
        'editorLineNumber.foreground': '#858585',
        'editorLineNumber.activeForeground': '#ffffff',
        'editorLineNumber.activeBg': '#404b52ff',
        'focusBorder': '#23233c',
        'inputOption.activeBorder': '#23233c',
    }
};
